module.exports = __webpack_public_path__ + "static/media/header-1.af4a9271.jpg";